import React, { FunctionComponent, useState } from "react";

import { IField } from "@/types/hubspot";
import FormFieldError from "../fieldError";

type Props = {
  field: IField;
  callback: Function;
};

const FormCheckbox: FunctionComponent<Props> = ({ field, callback }) => {
  const [checked, setChecked] = useState(
    field.defaultValue === "true" ? true : false,
  );

  const validateField = () => {
    setChecked(!checked);
    callback({
      ...field,
      value: !checked,
    });
  };

  return (
    <div className={`mb-4 ${field.hidden ? "hidden" : ""}`}>
      <div className="flex items-center">
        <input
          type="checkbox"
          id={field.name}
          name={field.name}
          className={`h-4 w-4 rounded ${field.error ? "border-red-500 bg-red-50 text-red-900 focus:ring-2 focus:ring-red-500" : "border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500"}`}
          required={field.required}
          defaultChecked={checked}
          aria-required={field.required}
          aria-invalid={field.error ? true : false}
          aria-errormessage={`error-${field.name}`}
          onChange={validateField}
        />
        <label
          htmlFor={field.name}
          className={`ms-2 text-sm font-medium ${field.error ? "text-red-700" : "text-gray-900"}`}
        >
          {field.label}
        </label>
      </div>
      <FormFieldError field={field} error={field.error} />
    </div>
  );
};

export default FormCheckbox;
